/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Pagination_Gotofirst2Inputs */

const id_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman pertama`)
};

const ms_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman pertama`)
};

const da_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til første side`)
};

const de_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur ersten Seite`)
};

const en_us2_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

const es_es2_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la primera página`)
};

const es_mx2_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la primera página`)
};

const fil_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumunta sa unang pahina`)
};

const fr_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la première page`)
};

const it_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla prima pagina`)
};

const hu_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugrás az első oldalra`)
};

const nl_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar eerste pagina`)
};

const no_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til første side`)
};

const pl_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do pierwszej strony`)
};

const pt_br2_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

const pt_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a primeira página`)
};

const ro_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mergi la prima pagină`)
};

const fi_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry ensimmäiselle sivulle`)
};

const sv_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till första sidan`)
};

const vi_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến trang đầu`)
};

const tr_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk sayfaya git`)
};

const cs_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na první stránku`)
};

const bg_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отидете на първа страница`)
};

const ru_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на первую страницу`)
};

const uk_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на першу сторінку`)
};

const ar_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقل إلى الصفحة الأولى`)
};

const hi_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले पृष्ठ पर जाएँ`)
};

const th_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปหน้าแรก`)
};

const ja_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のページへ`)
};

const zh_cn2_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

const zh_hant1_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

const ko_table_pagination_gotofirst2 = /** @type {(inputs: Table_Pagination_Gotofirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

/**
* | output |
* | --- |
* | "Go to first page" |
*
* @param {Table_Pagination_Gotofirst2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_pagination_gotofirst2 = /** @type {((inputs?: Table_Pagination_Gotofirst2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Pagination_Gotofirst2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_pagination_gotofirst2(inputs)
	if (locale === "ms") return ms_table_pagination_gotofirst2(inputs)
	if (locale === "da") return da_table_pagination_gotofirst2(inputs)
	if (locale === "de") return de_table_pagination_gotofirst2(inputs)
	if (locale === "en-US") return en_us2_table_pagination_gotofirst2(inputs)
	if (locale === "es-ES") return es_es2_table_pagination_gotofirst2(inputs)
	if (locale === "es-MX") return es_mx2_table_pagination_gotofirst2(inputs)
	if (locale === "fil") return fil_table_pagination_gotofirst2(inputs)
	if (locale === "fr") return fr_table_pagination_gotofirst2(inputs)
	if (locale === "it") return it_table_pagination_gotofirst2(inputs)
	if (locale === "hu") return hu_table_pagination_gotofirst2(inputs)
	if (locale === "nl") return nl_table_pagination_gotofirst2(inputs)
	if (locale === "no") return no_table_pagination_gotofirst2(inputs)
	if (locale === "pl") return pl_table_pagination_gotofirst2(inputs)
	if (locale === "pt-BR") return pt_br2_table_pagination_gotofirst2(inputs)
	if (locale === "pt") return pt_table_pagination_gotofirst2(inputs)
	if (locale === "ro") return ro_table_pagination_gotofirst2(inputs)
	if (locale === "fi") return fi_table_pagination_gotofirst2(inputs)
	if (locale === "sv") return sv_table_pagination_gotofirst2(inputs)
	if (locale === "vi") return vi_table_pagination_gotofirst2(inputs)
	if (locale === "tr") return tr_table_pagination_gotofirst2(inputs)
	if (locale === "cs") return cs_table_pagination_gotofirst2(inputs)
	if (locale === "bg") return bg_table_pagination_gotofirst2(inputs)
	if (locale === "ru") return ru_table_pagination_gotofirst2(inputs)
	if (locale === "uk") return uk_table_pagination_gotofirst2(inputs)
	if (locale === "ar") return ar_table_pagination_gotofirst2(inputs)
	if (locale === "hi") return hi_table_pagination_gotofirst2(inputs)
	if (locale === "th") return th_table_pagination_gotofirst2(inputs)
	if (locale === "ja") return ja_table_pagination_gotofirst2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_pagination_gotofirst2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_pagination_gotofirst2(inputs)
	return ko_table_pagination_gotofirst2(inputs)
});
export { table_pagination_gotofirst2 as "table.pagination.goToFirst" }